export default "__VITE_ASSET__YRaJOmmS__"